const columns = (renderCell, RenderJsonField, renderActions, renderValueCell) => [
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
    renderCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueGetter: (params) => params.row.details?.name ?? '',
    renderEditCell: renderValueCell
  },
  {
    field: 'details',
    headerName: 'Details',
    width: 300,
    renderCell: (params) => {
      const value = params.row.details?.properties ?? {};
      return <RenderJsonField value={value} />;
    }
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 250,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  },
];

export default columns;
